import { dataAppsSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAppsSolid = /*#__PURE__*/createIcon(dataAppsSolid)
export default IconAppsSolid
